<template>
    <div class="TTL-button">
    <el-button :type="option.type" @click="ChangeData">{{option.title}}</el-button>
    </div>
</template>

<script>
export default {
  props: ['value','option'],
  data() {
      return {
          option: {
              title:this.option && this.option.title ? this.option.title : '搜索',
              type:this.option && this.option.type ? this.option.type : '',
          },
      }
  },

  watch: {
      
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      ChangeData() {
          this.$emit('finish',{type:'change'});
      },

  }

}
</script>

<style scoped>

</style>